<template>
  <nav class="text-white mx-4.5 py-8">
    <div
      class="flex flex-row justify-between"
      :dir="$i18n.locale === 'ar' ? 'ltr' : 'rtl'">
      <div :style="isEezeeTheme ? 'color: black' : 'color: #02113C'" role="button" @click="onClickLocale">
        {{ $t('OppositeLanguage') }}
      </div>
      <div>
        <img
          v-if="this.isEezeeTheme"
          src="../../assets/zain_black.png"
          alt="Zain Logo"
          class="h-8 sm:h-12"
        />
        <img
            v-else
            src="../../assets/RedBullMobileLogo.svg"
            alt="RedBull Mobile Logo"
            class="h-10 sm:h-12"
        />
      </div>
    </div>

    <div
      v-if="
        !$store.state.queryIdInfoResult ||
        $store.state.queryIdInfoResult === 'error'  ||
        this.$route.path.startsWith('/eezee') ||
        this.$route.path.startsWith('/rbmz')
      "></div>
    <div
      v-else
      class="flex flex-col text-center justify-center items-center h-full">
      <h1 class="mt-3 text-xl">{{ $t($store.state.navText) }}</h1>
    </div>
  </nav>
</template>

<script>
import path from "path";

export default {
  name: 'EezeeNav',
  data() {
    return {
      isEezeeTheme: this.$route.path.startsWith('/eezee')
    }
  },
  components: {},
  methods: {
    path() {
      return path
    },
    onClickLocale() {
      this.$i18n.locale = this.$i18n.locale === 'ar' ? 'en' : 'ar'
      localStorage.setItem('locale', this.$i18n.locale)
    }
  }
}
</script>

<style scoped></style>
